<template>
  <b-modal
    ref="personalAccountModal"
    id="personalAccountModal"
    hide-header
    hide-footer
    modal-class="personal-accounts-modal"
    ignore-enforce-focus-selector=".webim-root"
  >
    <div class="personal-accounts__modal-close"
         @click="onCloseClick"
    >
      <svg class="personal-accounts__close-icon" width="24px" height="24px">
        <use xlink:href="#close-modal"></use>
      </svg>
    </div>
    <PersonalAccountItem
      :modal="true"
      :is-mobile-device="isMobileDevice"
    />
  </b-modal>
</template>
<script>
import PersonalAccountItem from './PersonalAccountItem.vue';
import iOS from '../../helpers/ios-detect';

export default {
  name: 'personalAccountModal',
  components: {
    PersonalAccountItem,
  },
  props: {
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      iosRestorePositionTop: null,
    };
  },
  mounted() {
    this.open();
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    open() {
      if (!this.isOpen) {
        this.isOpen = true;

        if (this.isMobileDevice && iOS()) {
          this.iosRestorePositionTop = window.pageYOffset;
        }

        this.$bvModal.show('personalAccountModal');
      }
    },
    onCloseClick() {
      this.$emit('close');
    },
    close() {
      if (this.isOpen) {
        this.isOpen = false;

        this.$bvModal.hide('personalAccountModal');

        if (this.isMobileDevice && iOS()) {
          this.restorePosition();
        }
      }
    },
    restorePosition() {
      if (iOS()) {
        window.scrollTo(0, this.iosRestorePositionTop);
      }
      this.$emit('hide');
    },
  },
};
</script>
